import React from 'react';
import { logger } from '@fiverr-private/obs';
import { ErrorBoundary, LazyComponent } from '@fiverr-private/ui_utils';
import { raiseToast } from '@fiverr-private/toast';
import { translate } from '@fiverr-private/i18n-react';
import type { SendMessageModalProps } from './types';

const lazyImport = () =>
    import(/* webpackChunkName: 'SendMessageModal' */ './SendMessageModal').then((m) => ({
        default: m.SendMessageModal,
    }));

type LazySendMessageModalProps = SendMessageModalProps & {
    afterLoad?: () => void;
    beforeLoad?: () => void;
    onError?: (error: unknown) => void;
};

export const LazySendMessageModal = (props: LazySendMessageModalProps) => (
    <ErrorBoundary
        onError={(error) => {
            logger.error(error, {
                description: 'Failed to lazy load Send Message Modal',
            });
            raiseToast({
                message: translate('help_menu.error'),
                type: 'error',
                location: 'top',
            });
            props.onError?.(error);
        }}
    >
        <LazyComponent<SendMessageModalProps>
            shouldImport={props.isOpen}
            lazyImport={lazyImport}
            componentProps={props}
            onError={props.onError}
            afterLoad={props.afterLoad}
            beforeLoad={props.beforeLoad}
        />
    </ErrorBoundary>
);
